// HTML tags allowed to be rendered across pipes
export const ALLOWED_TAGS = [
    'em',
    'strong',
    'i',
    'b',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'br',
    'ul',
    'ol',
    'li',
    'p',
] as const;
export type AllowedTag = (typeof ALLOWED_TAGS)[number];
